import React, { useState } from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
  Button,
  Modal,
  Card,
  CardContent,
  IconButton,
  Avatar,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

const drawerWidth = 240;

const ProfileDetails = () => {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  return (
    <Box
      component="main"
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        mt: { xs: 0, sm: '64px' },
        p: { xs: 2, md: 4 },
        backgroundColor: '#f8fafc',
        minHeight: '100vh',
      }}
    >
      <Container maxWidth="md">
        {/* Back Button - Fixed Top Left */}
        <Box sx={{ position: 'fixed', top: { xs: 16, sm: 80 }, left: { xs: 16, md: `calc(${drawerWidth}px + 16px)` }, zIndex: 1100 }}>
          <IconButton
            onClick={() => navigate(-1)}
            aria-label="Go back"
            sx={{
              bgcolor: 'background.paper',
              boxShadow: 3,
              '&:hover': { bgcolor: 'grey.100' },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>

        {/* Profile Card */}
        <Card
          sx={{
            mt: { xs: 2, sm: 4 },
            borderRadius: 4,
            boxShadow: 6,
            overflow: 'visible',
            background: 'linear-gradient(135deg, #fff7ed 0%, #fff0f5 100%)',
          }}
        >
          <CardContent sx={{ pt: 6, pb: 5, px: { xs: 3, md: 6 } }}>
            <Typography
              variant="h4"
              sx={{
                mb: 5,
                fontWeight: 'bold',
                color: '#1976d2',
                textAlign: 'center',
              }}
            >
              Profile Details
            </Typography>

            <Grid container spacing={4} alignItems="center">
              {/* Left Side: Profile Details */}
              <Grid item xs={12} md={6}>
                <Stack spacing={2.5}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Name: <span style={{ fontWeight: 400 }}>Roshni</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Phone Number: <span style={{ fontWeight: 400 }}>+1234567890</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Email: <span style={{ fontWeight: 400 }}>roshni@example.com</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Subjects: <span style={{ fontWeight: 400 }}>Mathematics, Science</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Subscription Status: <span style={{ fontWeight: 400, color: 'success.main' }}>Active</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Valid Thru: <span style={{ fontWeight: 400 }}>01/01/2025</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Expiry Thru: <span style={{ fontWeight: 400 }}>01/01/2026</span>
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Days Left: <span style={{ fontWeight: 400, color: 'warning.main' }}>35</span>
                  </Typography>
                </Stack>
              </Grid>

              {/* Right Side: Profile Image Upload */}
              <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: 'center' }}>
                  <Avatar
                    sx={{
                      width: 180,
                      height: 180,
                      mx: 'auto',
                      mb: 3,
                      border: '4px solid #fff',
                      boxShadow: 4,
                      bgcolor: '#e3f2fd',
                      fontSize: '4rem',
                    }}
                  >
                    R
                  </Avatar>

                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<PhotoCameraIcon />}
                    sx={{
                      borderRadius: 3,
                      px: 4,
                      py: 1.5,
                      textTransform: 'none',
                      fontSize: '1rem',
                    }}
                  >
                    Upload Photo
                    <input type="file" hidden accept="image/*" />
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Request Renewal Button */}
            <Box sx={{ mt: 6, textAlign: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleModalOpen}
                sx={{
                  px: 6,
                  py: 1.5,
                  borderRadius: 3,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                }}
              >
                Request Renewal
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>

      {/* Renewal Confirmation Modal */}
      <Modal open={openModal} onClose={handleModalClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: 400 },
            bgcolor: 'background.paper',
            borderRadius: 3,
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#1976d2' }}>
            Request Renewal
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Are you sure you want to request a renewal of your subscription?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleModalClose}
              sx={{ minWidth: 120 }}
            >
              Confirm
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleModalClose}
              sx={{ minWidth: 120 }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ProfileDetails;